import { gsap } from "gsap";
export class Utils {
    constructor() {

    }

    disableScrolling() {
        // jQuery('body').addClass('no-scroll')
    }

    enableScrolling() {
        // jQuery('body').removeClass('no-scroll')
    }

	static autoAlpha(elem, duration = 0.3, ease = "power2.inout") {
		gsap.fromTo(elem, {autoAlpha: 0}, {autoAlpha: 1, duration: duration, ease: ease})
	}

	static autoAlphaWithMovement(elem, duration = 0.3, ease = "power2.inout") {
		gsap.fromTo(elem, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, duration: duration, ease: ease})
	}
}
